import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import Select from 'react-select';
import { ADD_TEAM, LISTE_EQUIPE_SANS, TECHNICIEN_PAR_EQUIPE } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreAgent } from '../../store/agentStore';

export const AddTech = ({ libelle, id }) => {
    const agentData = [];
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [select, setSelect] = useState([])
    const technicien = useStoreAgent()

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_TEAM, 'application/json', { libelle: libelle, listAgentId: select.map((item) => (item.value)) }).then((res) => {
            setIsSubmit(false);
            if (res.status === 200) {
                technicien.technicienParEquipe(`${TECHNICIEN_PAR_EQUIPE}/${id}?page=0&param=&size=8`)
                document.getElementById('close').click()
                reset();
                toast.success('Equipe enregistrée ')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err.response.data.donnee)
        })
    }

    useEffect(() => {
        reset();
        technicien.technicienSansEquipe(`${LISTE_EQUIPE_SANS}?page=0&param=&size=8`)
    }, [])

    technicien?.technicienSans?.map((item) => {
        return agentData.push({ value: item.id, label: item.nomPrenoms })
    })

    return (
        <>
            <form onSubmit={handleSubmit(submit)} className='px-2'>
                <div className='my-4 space-y-4'>
                    <div className='my-2'>
                        <label htmlFor="" className='text-sm font-medium'>Techniciens</label>
                        <Select isMulti onChange={(e) => setSelect(e)} options={agentData} />
                    </div>

                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                        {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>
            </form>
        </>
    )
}
